export const lang={
    en:{
        search:"Search",
        searchBarPlaceHolder:"What do you like to watch today?"
    },
    Hindi:{
     search:"खोज",
        searchBarPlaceHolder:"आज आप क्या देखना पसंद करते हैं?"
    },
    Spanish:{
        search:"Buscar",
        searchBarPlaceHolder:"¿Qué te gusta ver hoy?"
    },
}